/**
 * Promise Utils
 */

export const makeCancelable: <TPromise>(promise: Promise<TPromise>) => ICancelablePromise<TPromise> = (promise) => {
  let hasCanceled = false;

  const wrappedPromise = new Promise<any>((resolve, reject) => {
    promise.then(
      (val) => hasCanceled ? reject({ isCanceled: true }) : resolve(val),
      (error) => hasCanceled ? reject({ isCanceled: true }) : reject(error),
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
};

export const emptyPromiseActionPayload: IPromiseActionPayload<any> = {
  promise: {
    resolve: () => null,
    reject: () => null,
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/promise.ts